import {gql} from '@apollo/client'

export const PREVIEW_ORDER_PRICE = gql`
    mutation previewOrderPrice($input: OrderCreateInput!) {
        previewOrderPrice(input: $input)
  }
`